import { entries, flatten, mapKeys, pick } from "lodash";

export const processErrors = <PayloadType>(
  errorMessage: string,
  formFields: (keyof PayloadType)[],
) => {
  try {
    const errorObj = JSON.parse(errorMessage);
    const fieldErrors = pick(errorObj, formFields);
    // Assuming field errors will only ever be string or string[]
    (Object.keys(fieldErrors) as (keyof PayloadType)[]).forEach(field => {
      fieldErrors[field] =
        typeof fieldErrors[field] !== "string"
          ? fieldErrors[field].join("; ")
          : fieldErrors[field];
    });
    const formErrors = flatten(
      (entries(errorObj) as [string, string[]][])
        .filter(pair => !(formFields as string[]).includes(pair[0]))
        .map(pair => pair[1]),
    );
    return {
      formErrors: formErrors.length !== 0 ? formErrors : null,
      fieldErrors,
    };
  } catch {
    return { formErrors: [errorMessage], fieldErrors: {} };
  }
};

export const translateFieldErrors = <T>(
  fieldErrors: Dictionary<string, string>,
  mapping: Dictionary<string, keyof T>,
) => {
  return mapKeys(
    pick(fieldErrors, Object.keys(mapping)),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (value, key) => mapping[key],
  );
};

export type Dictionary<K extends string, TK> = { [P in K]?: TK };

export type CoercedNumericType<T> = T extends number ? string : T;

export type CoercedObject<T extends Record<string, any>> = {
  [K in keyof T]: CoercedNumericType<T[K]>;
};
